var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[_c('div',{ref:"ScaleBox",staticClass:"ScaleBox",class:_vm.showColorBG ? 'x-scale-box-bg' : '',style:({
        width : _vm.width +'px',
        height : _vm.height +'px',
      })},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }